import {useMutation} from 'react-query';
import {postInternetInstallmentPay} from './postInternetInstallmentPay';

interface UsePostInternetInstallmentPayOptions {
  onSuccess?: (data: any, variables: void, context: unknown) => void;
  onError?: (error: Error, variables: void, context: unknown) => void;
}

const usePostInternetInstallmentPay = (
  loanGuid: string,
  options?: UsePostInternetInstallmentPayOptions,
) => {
  const {mutate, isLoading, ...rest} = useMutation({
    mutationFn: () => postInternetInstallmentPay(loanGuid),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {mutate, isLoading, ...rest};
};

export default usePostInternetInstallmentPay;
